<pos-app-spinner [show]="isBusy$ | async"></pos-app-spinner>
<div class="container-fluid py-2" *ngIf="{ values: lookupLists$ | async } as lookupLists">
  <div class="text-center">
    <h3 class="pt-3 arb-large-heading">MANAGE PARTNERS</h3>
  </div>
  <div class="card shadow-sm mt-4">
    <div class="card-body">
      <div class="row pb-4">
        <div class="col-3">
          <pos-app-lib-customer-search
            [customerType]="'billto'"
            (selectNewCustomer)="selectCustomer($event)"
            [forOrderSearch]="false"
            [selectedCustomerName]="
              selectedCustomer ? selectedCustomer?.customerName + ' (' + selectedCustomer?.customerNumber + ')' : selectedCustomerName || ''
            "
            [disabled]="preSelectedCustomerNumber"
            [showSearchIcon]="true"
            [removeCustomerAfterLoad]="true"
            placeHolder="CUSTOMER SEARCH"
            (focus)="isFocus($event)"
          ></pos-app-lib-customer-search>
        </div>
        <div class="col-3">
          <pos-app-lib-customer-external-search
            (selectNewCustomer)="selectCustomer($event)"
            [selectedCustomerName]="
              selectedCustomer ? selectedCustomer?.customerName + ' (' + selectedCustomer?.customerNumber + ')' : selectedCustomerName || ''
            "
            [disabled]="preSelectedCustomerNumber"
            [showSearchIcon]="true"
            [removeCustomerAfterLoad]="true"
            placeHolder="USER SEARCH"
            (focus)="isFocus($event)"
          ></pos-app-lib-customer-external-search>
        </div>
        <div class="col d-flex float-end justify-content-end">
          <button class="btn btn-secondary" type="button" (click)="navigateTo('/pos/partner/program')">MAINTAIN PARTNER PROGRAMMES</button>
        </div>

        <!-- ADD MAINTAIN PARTNER PROGRAMMES HERE -->
      </div>
    </div>
  </div>
  <div class="card shadow-sm mt-4" *ngIf="selectedCustomer">
    <div class="card-body">
      <form [formGroup]="globalUserSecurityForm">
        <div class="row">
          <div class="col" style="flex: 0 0 70%; max-width: 70%">
            <div class="row">
              <div class="col-6">
                <div class="col my-auto">
                  <label for="customer">CUSTOMER</label>
                </div>
                <div class="col my-auto">
                  <input
                    type="text"
                    class="form-control"
                    value="{{ this.selectedCustomer.customerName + '(' + this.selectedCustomer.customerNumber + ')' }}"
                    [readOnly]="true"
                  />
                </div>
              </div>
              <div class="col-6">
                <div class="col my-auto">
                  <label for="customer">PARTNER PROGRAMMES</label>
                </div>
                <div class="col my-auto">
                  <ng-select formControlName="partnerProgrammeCodes" [multiple]="true" [searchable]="true">
                    <ng-option *ngFor="let partnerProgramme of lookupLists.values?.partnerProgrammeList" [value]="partnerProgramme.programmeCode">
                      <span class="pe-1">{{ partnerProgramme.programmeCode }} -</span>
                      {{ partnerProgramme.programmeName }}
                    </ng-option>
                  </ng-select>
                </div>
              </div>
              <div class="mt-2">
                <label class="mt-2">ARB BRANCHES*</label>
                <div class="my-auto form-control-wrapper">
                  <ng-select
                    formControlName="allowedBranches"
                    [multiple]="true"
                    [searchable]="true"
                    [ngClass]="{
                      'is-invalid':
                        globalUserSecurityForm.get('allowedBranches').invalid &&
                        (globalUserSecurityForm.get('allowedBranches').dirty || globalUserSecurityForm.get('allowedBranches').touched)
                    }"
                    >>
                    <ng-option *ngFor="let branch of lookupLists.values?.branchList" [value]="branch.BranchCode.trim()">
                      <span class="pe-1" *ngIf="branch.BranchCode">{{ branch.BranchCode }} -</span>
                      {{ branch.BranchDescription }}
                    </ng-option>
                  </ng-select>
                  <span class="invalid-tooltip hover-tooltip">Requried at least one from ARB branches</span>
                </div>
              </div>
              <div class="mt-2">
                <label>NON-CORP BRANCHES</label>
                <div class="my-auto">
                  <ng-select formControlName="allowedNonCorps" [multiple]="true" [searchable]="true">
                    <ng-option *ngFor="let nonCorpStore of nonCorpStores" [value]="nonCorpStore.customerNumber.toString()">
                      <span class="pe-1" *ngIf="nonCorpStore.customerNumber">{{ nonCorpStore.customerNumber }} -</span>
                      {{ nonCorpStore.customerName }}
                    </ng-option>
                  </ng-select>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-2 form-control-wrapper">
                  <label for="customer">INVENTORY VIEW*</label>
                  <ng-select
                    formControlName="inventoryView"
                    [ngClass]="{
                      'is-invalid':
                        globalUserSecurityForm.get('inventoryView').invalid &&
                        (globalUserSecurityForm.get('inventoryView').dirty || globalUserSecurityForm.get('inventoryView').touched)
                    }"
                  >
                    <ng-option *ngFor="let inventoryView of lookupLists.values?.inventoryViewList" [value]="inventoryView.Code">
                      <span class="pe-1" *ngIf="inventoryView.Code">{{ inventoryView.Code }} -</span>
                      {{ inventoryView.Description }}
                    </ng-option>
                  </ng-select>
                  <span class="invalid-tooltip hover-tooltip">Requried</span>
                </div>
                <div class="col-8">
                  <label for="customer">VALID ORDER TYPES</label>
                  <ng-select
                    formControlName="validOrderTypes"
                    [items]="lookupLists.values?.orderTypeList"
                    [multiple]="true"
                    bindLabel="OrderTypeDescription"
                    bindValue="OrderTypeCode"
                    [searchable]="true"
                  >
                  </ng-select>
                </div>
                <div class="col-2">
                  <div class="col my-auto">
                    <label for="generic_Quote_Customer_Number"> CUSTOM PRICING</label>
                  </div>
                  <div class="col my-auto form-control-wrapper">
                    <input type="text" class="form-control" formControlName="customPricingFunction" maxlength="10" />
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-4">
                  <div class="col my-auto">
                    <label class="text-uppercase" for="generic_Quote_Customer_Number"> Override Showroom Price Code</label>
                  </div>
                  <ng-select
                    formControlName="overrideShowroomPriceCode"
                    [items]="priceScaleCodeList"
                    bindLabel="priceScaleDescription"
                    bindValue="priceScaleCode"
                    [searchable]="true"
                  ></ng-select>
                </div>
              </div>
            </div>
          </div>
          <div class="col" style="flex: 0 0 30%; max-width: 30%">
            <div class="row">
              <div class="row mb-2">
                <div class="col-12 col-sm-6 mb-2 mb-sm-0">
                  <button class="btn btn-secondary w-100" type="button" [disabled]="formValid" (click)="navigateToMaintainUser()">
                    MAINTAIN USER
                  </button>
                </div>
                <div class="col-12 col-sm-6">
                  <button class="btn btn-secondary w-100" type="button" [disabled]="formValid" (click)="openAddShipToModal()">ADD SHIP TO</button>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <label>SETTINGS</label>
                  <div class="">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="ARBuAvailableYN"
                      [checked]="globalUserSecurityForm.get('ARBuAvailableYN')?.value"
                    />
                    <label class="ps-2">ARB-U AVAILABLE</label>
                  </div>
                  <div class="">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="displayCurrencyYN"
                      [checked]="globalUserSecurityForm.get('displayCurrencyYN')?.value"
                    />
                    <label class="ps-2">SHOW CURRENCY</label>
                  </div>
                  <div class="">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="displayIncTaxYN"
                      [checked]="globalUserSecurityForm.get('displayIncTaxYN')?.value"
                    />
                    <label class="ps-2">SHOW INC TAX PRICES</label>
                  </div>
                  <div class="">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="displayExTaxYN"
                      [checked]="globalUserSecurityForm.get('displayExTaxYN')?.value"
                    />
                    <label class="ps-2">SHOW EX TAX PRICES</label>
                  </div>
                  <div class="">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="showNationalInventoryYN"
                      [checked]="globalUserSecurityForm.get('showNationalInventoryYN')?.value"
                    />
                    <label class="ps-2">SHOW NATIONAL INV</label>
                  </div>
                  <div class="">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="defaultXRefPartsTF"
                      [checked]="globalUserSecurityForm.get('defaultXRefPartsTF')?.value"
                    />
                    <label class="ps-2">DEFAULT X-REF PARTS</label>
                  </div>
                  <div class="">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="saveQuotesTF"
                      [checked]="globalUserSecurityForm.get('saveQuotesTF')?.value"
                    />
                    <label class="ps-2">SAVE QUOTES</label>
                  </div>
                  <div class="">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="genericQuotesOnlyTF"
                      [checked]="globalUserSecurityForm.get('genericQuotesOnlyTF')?.value"
                    />
                    <label class="ps-2">GENERIC QUOTES ONLY</label>
                  </div>
                  <div class="">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="allowProgrammeLoginOnlyTF"
                      [checked]="globalUserSecurityForm.get('allowProgrammeLoginOnlyTF')?.value"
                    />
                    <label class="ps-2">PROGRAMME LOGIN ONLY</label>
                  </div>
                </div>
                <div class="col-6">
                  <label>SECURITY ALLOWED</label>
                  <div class="">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="SeeBuyPrice"
                      [checked]="globalUserSecurityForm.get('SeeBuyPrice')?.value"
                    />
                    <label class="ps-2">SEE BUY PRICE</label>
                  </div>
                  <div class="">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="MaintainOrders"
                      [checked]="globalUserSecurityForm.get('MaintainOrders')?.value"
                    />
                    <label class="ps-2">MAINTAIN ORDERS</label>
                  </div>
                  <div class="">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="AccountScreen"
                      [checked]="globalUserSecurityForm.get('AccountScreen')?.value"
                    />
                    <label class="ps-2">ACCOUNT SCREEN</label>
                  </div>
                  <div class="">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="SeeCostMaster"
                      [checked]="globalUserSecurityForm.get('SeeCostMaster')?.value"
                    />
                    <label class="ps-2">SEE COST MASTER</label>
                  </div>
                  <div class="">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="ViewStock"
                      [checked]="globalUserSecurityForm.get('ViewStock')?.value"
                    />
                    <label class="ps-2">VIEW STOCK</label>
                  </div>
                  <div class="">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="ManageUsers"
                      [checked]="globalUserSecurityForm.get('ManageUsers')?.value"
                    />
                    <label class="ps-2">MANAGE USERS</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card shadow-sm mt-2" *ngIf="selectedCustomer && globalUserSecurityForm.get('shipTos')?.value.length > 0">
          <div class="card-body">
            <div class="table-responsive tableFixHead">
              <table class="border table table-bordered">
                <thead>
                  <tr>
                    <th scope="col" class="text-uppercase text-center">
                      <label>Action</label>
                    </th>

                    <th scope="col" class="text-uppercase text-center">
                      <label>SHIP TO</label>
                    </th>
                    <th scope="col" class="text-uppercase text-center">
                      <label>DEFAULT BRANCH</label>
                    </th>
                  </tr>
                </thead>
                <tbody formArrayName="shipTos">
                  <tr *ngFor="let shipTo of shipTos.controls; let i = index" [formGroupName]="i">
                    <td>
                      <div class="d-flex">
                        <mat-icon (click)="removeShipTo(i)" title="Delete" *ngIf="i !== 0">delete</mat-icon>
                      </div>
                    </td>
                    <td>{{ shipTo.value.shipToName }} ({{ shipTo.value.shipToNumber }})</td>
                    <td class="form-control-wrapper" style="max-width: 150px">
                      <div
                        [ngClass]="{
                          'is-invalid':
                            isBranchInValid(shipTo) || globalUserSecurityForm.get('shipTos').get(i.toString()).get('defaultBranch').invalid
                        }"
                      >
                        <select class="form-select" formControlName="defaultBranch">
                          <option *ngFor="let shipTo of allCombinedBranchesList" [value]="shipTo.branchCode" style="position: absolute">
                            <span class="pe-1" *ngIf="shipTo.branchCode">{{ shipTo.branchCode }} -</span>
                            {{ shipTo.branchName }}
                          </option>
                        </select>
                      </div>
                      <span
                        *ngIf="isBranchInValid(shipTo) || globalUserSecurityForm.get('shipTos').get(i.toString()).get('defaultBranch').invalid"
                        class="invalid-tooltip hover-tooltip bg-danger text-white"
                      >
                        This branch doesn't belong to ARB branches or Non-Corp branches</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-2 mt-2 d-flex float-end justify-content-end">
          <button class="btn btn-reset mx-1 px-2" *ngIf="formValid" (click)="resetFormSelectedCustomer()">RESET</button>
          <button class="btn btn-cancel mx-1 px-2" (click)="cancel()">CANCEL</button>
          <button class="btn text-white mx-1 px-2" (click)="updateGlobalSetting()" [disabled]="!globalUserSecurityForm.valid || !formValid">
            SAVE
          </button>
        </div>
      </form>
    </div>
  </div>

  <ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h3 class="arb-large-heading" id="modal-basic-title">
        {{ isGarage ? 'ADD SHIP TO' : '' }}
      </h3>
    </div>
    <div class="modal-body">
      <div *ngIf="isGarage">
        <app-customers-ship-to-form
          (formChanged)="formValue = $event"
          (formIsValid)="formValid = $event"
          (formIsDirty)="formDirtyHandler($event)"
          [soldToCustomer]="selectedCustomerDetails$ | async"
          [lookupLists]="lookupLists$ | async"
          (submitByEnter)="(formValid)"
          (cancelled)="cancel()"
          (selectedCountry)="getFilteredStateList($event)"
          [filteredStateList]="filteredStateList"
          [disabledDefaultBillto]="true"
        >
        </app-customers-ship-to-form>

        <div class="d-flex float-end">
          <button class="col-sm-6 btn btn-cancel m-2" (click)="handleCloseModal(true)">CANCEL</button>
          <button class="col-sm-4 btn text-white my-2" (click)="saveShipTo()" [disabled]="!formValid">SAVE</button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
